import HttpClient from 'services/api';
import { ENDPOINTS } from 'services/api/endpoints';

// Cria um noco caso
export const purchaseCase = (id, payload) => HttpClient.patch(ENDPOINTS.CASE_PURCHASE.replace(':case', id), payload);

// Retorna dados do caso pelo ID
export const getCaseById = (id) => HttpClient.get(ENDPOINTS.GET_CASE.replace(':id', id));

// Cria um novo caso
export const createCase = (payload) => HttpClient.post(ENDPOINTS.CASE, payload);

// Envia os arquivos por email (petição, cálculo)
export const sendEmail = (id, payload) => HttpClient.post(ENDPOINTS.SEND_EMAIL.replace(':id', id), payload);
